import { DateRange } from '@ssp/inscreva-sse-models';
import moment from 'moment';

export abstract class EventDateHelper {
  public static isSameDay(date: DateRange) {
    return (
      moment(date.end).endOf('day').diff(moment(date.start).startOf('day'), 'days') === 0 ||
      moment(date.end).diff(date.start, 'days') === 0
    );
  }

  public static isBetween(date: DateRange, rangeToCompare: DateRange) {
    return (
      moment(date.start).isBetween(rangeToCompare.start, rangeToCompare.end, null, '[]') ||
      moment(date.end).isBetween(rangeToCompare.start, rangeToCompare.end, null, '[]')
    );
  }
}
